import React from "react";
import "./footer.css";
const Footer = () => {
  return (
    <div className="footer">
      <div className="footerWrapper">
        <h3>Developed and Maintained © Umesh Kumar </h3>
      </div>
    </div>
  );
};

export default Footer;
